import script from "./ShopItem.vue?vue&type=script&lang=ts&setup=true"
export * from "./ShopItem.vue?vue&type=script&lang=ts&setup=true"

import "./ShopItem.vue?vue&type=style&index=0&id=0aeb065e&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0aeb065e"]])

export default __exports__